export default  [
  { value:'data-table-select', text: '', fixed: true, width: '5%'},
  { text: '#', value: 'index', align: 'center', width: "5%"},
  { text: 'URL', value: 'url', align: 'center', width: "45%"},
  { text: 'Link', value: 'link', align: 'center',width: "45%"},
]